import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

const styles = (theme: Theme): SerializedStyles => css`
  &.MuiButton-contained {
    box-shadow: none;
    // spacing(8) looks good-ish right now. Probably will still cause
    // some button with very long text to span multiple lines.
    padding-left: ${theme.mui.spacing(8)}px;
    padding-right: ${theme.mui.spacing(8)}px;
    ${theme.mui.breakpoints.up('sm')} {
      min-width: unset;
      padding-left: ${theme.mui.spacing(14)}px;
      padding-right: ${theme.mui.spacing(14)}px;
    }
    max-width: 100%;
    font-weight: bold;

    .MuiButton-label {
      // if the label is forced onto two lines, it looks less goofy if centered
      text-align: center;
    }
    text-transform: none;
  }
  &.MuiButton-containedPrimary {
    transition: ${theme.mui.transitions.create(['color', 'background-color'])};
    &:hover {
      // Primary button hover uses primary.dark by default.
      // We need to make sure that if it is changing from a light to a
      // dark button (due to a light brandColor or something), the text color
      // is also switched.
      color: ${theme.mui.palette.getContrastText(
        theme.mui.palette.primary.dark,
      )};
    }
  }
  &.MuiButton-textPrimary {
    &:hover {
      // Primary button hover uses primary.dark by default.
      // We need to make sure that if it is changing from a light to a
      // dark button (due to a light brandColor or something), the text color
      // is also switched.
      background-color: transparent;
    }

    .MuiButton-label {
      text-transform: none;
      font-style: italic;
      text-decoration: underline;
    }

    padding-top: 6px; // Mui hardcode this values to be 6px
    padding-bottom: 6px;
  }
  &.MuiButton-text {
    // Make sure the text is inside the curved border radius.
    padding-left: ${theme.mui.spacing(6) / 2}px;
    padding-right: ${theme.mui.spacing(6) / 2}px;
  }
  &.MuiButtonBase-root {
    border-radius: 5px;
    // These values make the normal size button exactly 48px tall in Chrome.
    // (It's slightly off in the other browsers).
    // ADS requires button to be at least 44px tall.
    // Using min-height causes alignment issue in IE11.
    padding-top: 12px; // Mui hardcode this values to be 6px
    padding-bottom: 12px;
    font-style: normal;
  }
`;

export default styles;
